module.exports = __webpack_public_path__ + "static/img/b3.a68d312.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/b3.png
// module id = NN0U
// module chunks = 1